import React, { useEffect, useState } from "react";
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  Toolbar,
  Typography,
} from "@mui/material";
import "../../assets/styles.css";
import { Link, useLocation } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

interface HeaderProps {
  title: string;
  breadCrumb?: any;
  breadCrumbBar?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({ title, breadCrumb, breadCrumbBar }) => {
  return (
    <>
      <AppBar className="TopHeader" position="fixed" sx={{ zIndex: 1 }}>
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: breadCrumb ? "left" : "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            noWrap
            sx={{
              overflow: "none",
              paddingLeft: "75px",
              fontSize: "24px",
              gap: "8px",
            }}
          >
            {title}
          </Typography>

          {breadCrumb && (
            <Box sx={{ display: "flex", gap: "10px" }}>
              {breadCrumb?.map((i: any, index: any) => {
                const isLast = breadCrumb?.length === index + 1;
                return (
                  <Typography
                    key={index}
                    sx={{ color: isLast ? "#A5A8A9" : "#17B2EB" }}
                  >
                    {!isLast ? (
                      <Link
                        to={i?.path}
                        style={{ color: "unset", textDecoration: "none" }}
                        onClick={(e) => {
                          if (i.onClick) {
                            i.onClick(e);
                          }
                        }}
                      >
                        {i?.label}
                      </Link>
                    ) : (
                      i?.label
                    )}
                    {!isLast && (
                      <ArrowForwardIosIcon
                        sx={{
                          height: "12px",
                          width: "14px",
                          fill: "#17B2EB",
                        }}
                      />
                    )}
                  </Typography>
                );
              })}
            </Box>
          )}
        </Toolbar>
        {breadCrumbBar && breadCrumbBar}
      </AppBar>
    </>
  );
};

export default Header;

